export const ADDRESS_UPDATE_REQUEST = 'ADDRESS_UPDATE_REQUEST'
export const ADDRESS_UPDATE_SUCCESS = 'ADDRESS_UPDATE_SUCCESS'
export const ADDRESS_UPDATE_ERROR   = 'ADDRESS_UPDATE_ERROR'
export const ADDRESS_UPDATE_LOGOUT  = 'ADDRESS_UPDATE_LOGOUT'
